import React from "react"
import { Loader } from "@/UI"
import KosmoButton from "@/UI/Buttons/KosmoButton"
import { useTeams } from "@/hooks/useTeams"
import SettingContentWrapper from "@/modules/shared/SettingContentWrapper"
import SettingSection from "@/modules/shared/SettingSection"
import { isEmpty } from "lodash"
import { Trans, useTranslation } from "react-i18next"
import CreateTeamModal from "./components/CreateTeamModal"
import TeamsTable from "./components/TeamsTable"
import { useRecoilValue } from "recoil"
import { isManagerSelector } from "@/atoms/userAtom"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useZones } from "@/hooks/useZones"

interface TeamSettingsProps {}

const TeamSettings: React.FC<TeamSettingsProps> = () => {
  const { t } = useTranslation()

  const { teams, isLoading, enrichedTeams } = useTeams()
  const isManager = useRecoilValue(isManagerSelector)
  const { zones } = useZones()

  if (isLoading) {
    return (
      <SettingSection title={t("common.teams")}>
        <div className="absolute" style={{ top: "45%", left: "55%" }}>
          <Loader fontSize={48} />
        </div>
      </SettingSection>
    )
  }

  return (
    <SettingSection
      title={t("common.teams")}
      actionButton={
        <>
          {!isManager && (
            <div className="flex w-full justify-end">
              <CreateTeamModal
                button={
                  <KosmoButton id="create-new-team-button" type="primary">
                    <div className="flex items-center gap-x-2">
                      <FontAwesomeIcon icon={faPlus} color="#FFF" />
                      <p>{t("profile.TeamsSettings.createTeam")}</p>
                    </div>
                  </KosmoButton>
                }
              />
            </div>
          )}
        </>
      }
    >
      {isEmpty(teams) ? (
        <SettingContentWrapper>
          <div className="flex flex-col items-center gap-y-4">
            <p className="font-bold text-center">
              {<Trans i18nKey={"profile.teams.createYourFirstFleet"} components={{ 1: <br /> }} />}
            </p>
            {!isManager && (
              <CreateTeamModal
                button={
                  <KosmoButton id="create-new-team-button" type="primary">
                    <div className="flex items-center gap-x-2">
                      <FontAwesomeIcon icon={faPlus} color="#FFF" />
                      <p>{t("profile.TeamsSettings.createTeam")}</p>
                    </div>
                  </KosmoButton>
                }
              />
            )}
          </div>
        </SettingContentWrapper>
      ) : (
        <div className="flex flex-col w-full gap-y-4">
          <TeamsTable teams={enrichedTeams} zones={zones} />
        </div>
      )}
    </SettingSection>
  )
}

export default TeamSettings
